import React, { Component } from "react";

class IconFacebook extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <svg width="20px" height="20px" viewBox="0 0 20 20" role="presentation">
                <g stroke="none" strokeWidth="1" fillRule="evenodd">
                    <g>
                        <path
                            d="M18,-3.19744231e-14 L2,-3.19744231e-14 C0.9,-3.19744231e-14 -2.48689958e-14,0.9 -2.48689958e-14,2 L-2.48689958e-14,18 C-2.48689958e-14,19.1 0.9,20 2,20 L10.249,20 L10.249,12.405 L7.493,12.405 L7.493,9.661 L10.249,9.661 L10.249,7.549 C10.249,4.965 12.204,3.432 14.51,3.432 C15.613,3.432 16.194,3.55 16.472,3.587 L16.472,6.202 L14.517,6.202 C13.263,6.202 13.029,6.823 13.029,7.698 L13.029,9.661 L16.509,9.661 L16.056,12.405 L13.029,12.405 L13.029,20 L18,20 C19.1,20 20,19.1 20,18 L20,2 C20,0.9 19.1,-3.19744231e-14 18,-3.19744231e-14"
                            id="Fill-1"
                        ></path>
                    </g>
                </g>
            </svg>
        );
    }
}

export default IconFacebook;
